import { ComponentChildren, h } from "preact";

import classname from "../../../foundation/utils/classname";
import IconCloseForVertical from "../Icons/IconClose";
import IconCloseForHorizontal from "../Icons/IconCloseSmall";
import Button, { ButtonProps } from "../Button";
import Chip, { ChipProps } from "../Chip";
import NinjaTextButton from "../NinjaTextButton";

import styles from "./Announcement.module.css";

type AnnouncementButtonProps = Pick<ButtonProps, "children" | "onClick">;

enum Orientation {
    Horizontal = "horizontal",
    Vertical = "vertical"
}

interface Props {
    class?: string;
    orientation?: Orientation;
    image?: ComponentChildren;
    chipProps?: ChipProps;
    title: string;
    description: string;
    info?: string;
    primaryButtonProps?: AnnouncementButtonProps;
    secondaryButtonProps?: AnnouncementButtonProps;
    onClose: () => void;
}

function Announcement({
    class: cssClass,
    orientation = Orientation.Horizontal,
    image,
    chipProps,
    title,
    description,
    info,
    primaryButtonProps,
    secondaryButtonProps,
    onClose
}: Props) {
    const IconClose = orientation === Orientation.Vertical ? IconCloseForVertical : IconCloseForHorizontal;
    return (
        <div
            class={classname(styles.announcement, cssClass, styles[orientation], {
                [styles.noImage]: !image
            })}>
            {image && (
                <div class={styles.imageContainer}>
                    {image}
                </div>
            )}
            <div class={styles.body}>
                {chipProps && <Chip {...chipProps}/>}
                <span class={classname(styles.title, "heading-4 medium", {
                    [styles.noChip]: !chipProps
                })}>
                    {title}
                </span>
                <span class={classname(styles.description, "body-1")}>{description}</span>
                {info && <span class={classname(styles.info, "body-1")}>{info}</span>}
                <div class={styles.footer}>
                    {primaryButtonProps && <Button {...primaryButtonProps}/>}
                    {secondaryButtonProps && <NinjaTextButton {...secondaryButtonProps}/>}
                </div>
            </div>
            <div
                class={styles.iconContainer}
                onClick={onClose}>
                <IconClose/>
            </div>
        </div>
    );
}

export default Announcement;
export {
    Props as AnnouncementProps,
    Orientation as AnnouncementOrientation
};
